import { HttpClient } from '@opallabs/api'
import reducePostPlacement from '../reducePostPlacement'

const postPostPlacement = ({ content_id, placement_id }) =>
  HttpClient().post(`/content/v2/${content_id}/placements/${placement_id}`, {
    params: {
      include: 'account,posts',
    },
  })

const createPostPlacement = (options) => (dispatch) =>
  postPostPlacement(options)
    .then((response) => {
      const body = response.data

      if (body.data) {
        const { content_id, placement_id } = options

        dispatch(
          reducePostPlacement({
            content_id,
            placement_id,
            create: true,
          })
        )
      }

      return {}
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default createPostPlacement
